import { SimpleLocalizedError, type Localizable } from "@/modules/l10n/getTransText.ts";
import { msg } from "@lingui/core/macro";
import type { PersistentDataResponse } from "@warrenio/api-spec/spec.oats.gen";

/** @public */
export class RazorpayError extends SimpleLocalizedError {
    name = "RazorpayError";

    constructor(
        public readonly code: "failed" | "other",
        localeMessage: Localizable,
    ) {
        super(localeMessage);
    }
}

export function parseRazorpayPaymentResult(response: PersistentDataResponse) {
    switch (response.status) {
        case "success":
            return response;
        case "failed":
            throw new RazorpayError("failed", msg`Payment failed`);
        default:
            return null; // status still pending
    }
}
